import React, { useEffect, useRef, useState, useContext } from "react";
import "./Studio_card_one.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faStar } from "@fortawesome/free-solid-svg-icons";
import Book_studio_modal from "../../common-section/Modals/book-studio-modal/Book_studio_modal";
import parse from "html-react-parser";
import { Context } from "../../../utils/context";
import { useNavigate } from "react-router-dom";
const Studio_card_one = ({ data }) => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = React.useState(false);
  const { IMG_URL, signin } = useContext(Context);
  const [mapSrc, setMapSrc] = useState("");
  const handleBookClick = () => {
    if (signin) {
      setModalShow(true);
    } else {
      navigate("/login"); // Redirect to the login page
    }
  };

  console.log("map", data)


  useEffect(() => {
    if (data?.lat && data?.long) {
      setMapSrc(
        `https://maps.google.com/maps?width=600&height=400&hl=en&q=${data.lat},${data.long}&t=&z=14&ie=UTF8&iwloc=B&output=embed`
      );
    }
  }, [data]);

  // const ratings = data?.studio_reviews?.map((rate) => rate?.ratings);


  // const totalRatings = ratings?.reduce((sum, rating) => sum + rating, 0);

  // const averageRating =
  //   ratings && ratings.length > 0 ? totalRatings / ratings.length : 0;

  return (
    <>
      <section className="Studio_card_one">
        <div className="container">
          <div className="row card-bgg">
            {/* <div className=''></div> */}
            <div className="col-xxl-7 col-lg-6 p-4">
              <div className="sec-1">
                <div className="location_holder">

                  <h1 className="stud-one">
                    {data?.name} <span>{data?.address}</span>
                  </h1>

                  <div >
                    <div
                      className="map-icon"
                      onClick={() => {
                        if (data?.lat && data?.long) {
                          const mapUrl = `https://www.google.com/maps?width=600&height=400&hl=en&q=${data.lat},${data.long}&t=&z=14&ie=UTF8&iwloc=B&output=svembed`;
                          window.open(mapUrl, "_blank"); // Open "View Larger Map" in a new tab
                        } else {
                          alert("Location details are not available.");
                        }
                      }}
                    >
                      <FontAwesomeIcon
                        className="location-icon"
                        icon={faLocationDot}
                      />
                    </div>
                  </div>
                </div>

                <p className="starp">
                  {data?.average_rating}{" "}
                  <FontAwesomeIcon className="staricon" icon={faStar} />
                </p>

                <p className="contett">
                  {typeof data?.description === "string"
                    ? parse(data?.description)
                    : ""}
                </p>

                <div className="d-flex">
                  <button
                    className="book-btn"
                    type="button"
                    onClick={handleBookClick}
                  >
                    Book
                  </button>
                  <div className="my-auto">
                    <p className="startinfp">

                      {data?.service_charge?.hourly_basis_charges
                        ? `Starting from: ₹ ${data.service_charge.hourly_basis_charges}/Hr`
                        : data?.service_charge?.per_rate
                          ? `Starting from: ₹ ${data.service_charge.per_rate}`
                          : data?.service_charge?.fix_amount
                            ? `Starting from: ₹ ${data.service_charge.fix_amount}`
                            : null}
                    </p>
                  </div>
                </div>

                <Book_studio_modal
                  name={data?.name}
                  studio_id={data?.id}
                  image={data?.services_images[0]?.images}
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                />
              </div>
            </div>
            <div className="col-xxl-5 col-lg-6 p-4">
              <img
                className="stud-img"
                src={IMG_URL + data?.services_images[0]?.images}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Studio_card_one;
